<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('fabric_label_groupSpecName') || '规格名称'"
            prop="groupSpecName"
          >
            <dict-select
              :disabled="disabled"
              v-model="formData.groupSpecName"
              url="factory/order/demand/fabric/selectGroupSpecName"
              :body="{ orderCode: orderCode }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_detail_material_category') || '2级物料分类'
            "
            prop="detailMaterialCategoryCode"
            ref="detailMaterialForm"
          >
            <dict-select
              size="mini"
              clearable
              filterable
              v-model="formData.detailMaterialCategoryCode"
              :body="detailMaterialParams"
              :disabled="
                formData.mainMaterialCategoryCode == null ||
                  formData.mainMaterialCategoryCode == ''
              "
              @change="updateMaterial"
              url="/master/material/category/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_accessories_no') || '辅料编号'"
            ref="material"
            prop="materialNo"
          >
            <el-input clearable v-model="formData.materialNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="addMaterial"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_accessories_name') || '物料名称'"
            prop="materialName"
          >
            <el-input v-model="formData.materialName" readonly :size="'mini'">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_accessories_specifications') || '辅料规格'"
            prop="materialSpec"
          >
            <el-input v-model="formData.materialSpec" :size="'mini'">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('table_label_accessories_qty') || '用量'"
            prop="qty"
          >
            <el-input-number
              v-model="formData.qty"
              style="width:100%"
              :min="1"
              :precision="0"
              :step="1"
              controls-position="right"
              size="mini"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('table_label_accessories_unit') || '物料单位'"
            prop="materialUnit"
          >
            <dict-select
              size="mini"
              clearable
              filterable
              v-model="formData.materialUnit"
              :body="materialUnitParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_isCommon') || '是否是通用物料'"
            prop="isCommon"
            ><br />
            <el-radio-group
              size="mini"
              v-model="formData.isCommon"
              @change="isCommonChange"
            >
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_isCustomerProvide') || '是否客供'
            "
            prop="isCustomerProvide"
            ><br />
            <el-radio-group size="mini" v-model="formData.isCustomerProvide">
              <el-radio label="Y">
                {{
                  this.$l('INDEX.order_form_label_isCustomerProvide_Y') || '是'
                }}
              </el-radio>
              <el-radio label="N">
                {{
                  this.$l('INDEX.order_form_label_isCustomerProvide_N') || '否'
                }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_isSpecify') || '客户指定供应商'"
            ><br />
            <el-radio-group size="mini" v-model="formData.isSpecify">
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_isFactoryConfirm') || '是否工厂确认'"
            ><br />
            <el-radio-group size="mini" v-model="formData.isFactoryConfirm">
              <el-radio label="1">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="0">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <dict-select
              size="mini"
              clearable
              :disabled="this.formData.isSpecify === 'N'"
              filterable
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('batch_label_outBillType') || '出单类型'"
            prop="outBillType"
          >
            <dict-select
              filterable
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :placeholder="
                $l('tips_batch_label_outBillType') || '请选择出单类型'
              "
              :body="outBillTypeParams"
              size="mini"
              clearable
              :disabled="formData.isCommon === 'Y'"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('batch_label_dispatchPort') || '发运港口'"
            prop="dispatchPort"
          >
            <dict-select
              filterable
              v-model="formData.dispatchPort"
              url="/master/port/select"
              :placeholder="
                $l('tips_batch_label_dispatchPort') || '请选择发运港口'
              "
              size="mini"
              clearable
              :disabled="formData.isCommon === 'Y'"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('batch_label_destinationPort') || '目的港口'"
            prop="destinationPort"
          >
            <dict-select
              filterable
              v-model="formData.destinationPort"
              url="/master/port/select"
              :placeholder="
                $l('tips_batch_label_destinationPort') || '请选择目的港口'
              "
              size="mini"
              clearable
              :disabled="formData.isCommon === 'Y'"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <TechDocList
          :materialDocList="this.formData.materialDocList"
          :disabled="disabled"
          ref="techDoc"
        />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-material-dialog
      :title="$l('INDEX.material_choose_title') || '添加物料信息'"
      :visible.sync="visible"
      :productLine="formData.productLine"
      :detailMaterialCategoryCode="formData.detailMaterialCategoryCode"
      :mainMaterialCategoryCode="formData.mainMaterialCategoryCode"
      type="radio"
      @confirm="onMaterialConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import TechDocList from './tech-doc-list'
export default {
  components: { TechDocList },
  mixins: [EditLoading],
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    code: {
      default: '',
      type: String,
    },
    orderCode: {
      default: '',
      type: String,
    },
    copyDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      Disable: true,
      goodsProofingData: [],
      backDialogVisible: false,
      visible: false,
      productLineParams: { dictType: 'productLine' },
      outBillTypeParams: { dictType: 'outBillType' },
      materialUnitParams: { dictType: 'moqUnit' },
      mainMaterialParams: {},
      scmCode: '',
      detailMaterialParams: {
        parentCode: '1ab7e2b2-5b3d-45f9-950a-a552489998e9',
      },
      formData: {
        isSpecify: 'N',
        orderGoodsProofingStatus: 'N',
        productLine: 'ABSHome',
        mainMaterialCategoryCode: '1ab7e2b2-5b3d-45f9-950a-a552489998e9',
        materialCode: '',
        materialNo: '',
        materialName: '',
        materialNameEn: '',
        scmCode: '',
        materialDisplayName: '',
        materialSpec: '',
        groupSpecName: '',
        isCommon: 'Y',
        isCustomerProvide: 'N',
        isFactoryConfirm: '0',
        qty: 1,
      },
      rules: {
        groupSpecName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        materialNo: [
          {
            required: true,
            message:
              this.$l('form_label_pe_accessories_no') || '请选择辅料编号',
            trigger: 'change',
          },
        ],
        isCommon: [
          {
            required: true,
            message:
              this.$l('tips_form_label_isCommon') || '请选择是否是通用辅料',
            trigger: 'change',
          },
        ],
        materialSpec: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        materialUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .orderDemandMaterialDetailApi({
          orderMaterialCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          if (this.copyDisabled) {
            this.formData.orderMaterialCode = ''
          }
        })
    },

    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      let params = {
        ...this.formData,
        orderCode: this.orderCode,
      }

      if (this.formData.isFactoryConfirm === '0'){
        const techDocList = this.$refs.techDoc.getTableData()
        params.materialDocList = techDocList
        if (!techDocList || !techDocList.length) {
          this.$message.warning(
            this.$l('INDEX.tips_upload_file') || `请选择需要上传的文件`
          )
          return
        }
      }
      this.loadingOpen()
      this.$api
        .orderDemandMaterialAddSaveApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.goodsProofingData = []
      this.$emit('close')
    },
    addMaterial() {
      const { detailMaterialCategoryCode } = this.formData
      if (!detailMaterialCategoryCode) {
        this.$message.warning(
          this.$l('INDEX.pe_select_Level_2_material_classification') ||
            '请选择2级物料分类'
        )
        return
      }
      this.visible = true
    },
    goodsSpecDialogClose() {
      this.visible = false
    },

    updateMaterial() {
      this.formData.materialCode = ''
      this.formData.materialNo = ''
      this.formData.materialName = ''
      this.formData.materialNameEn = ''
      this.formData.scmCode = ''
      this.formData.materialDisplayName = ''
      this.formData.materialSpec = ''
    },
    onMaterialConfirm(data) {
      if (!data) return
      this.formData.materialCode = data.materialCode
      this.formData.materialNo = data.materialNo
      this.formData.materialName = data.materialName
      this.formData.materialNameEn = data.materialNameEn
      this.formData.scmCode = data.scmCode
      this.formData.materialDisplayName = data.materialName
      this.formData.materialSpec = ''
    },

    isCommonChange() {
      if (this.formData.isCommon === 'Y') {
        this.formData.outBillType = ''
        this.formData.dispatchPort = ''
        this.formData.destinationPort = ''
      }
    },
  },
}
</script>
